import React, { useState } from 'react';

export function AccountPage({ profile, onSetPassword, onUpdateProfile }) {
  const [pw, setPw]       = useState('');
  const [pw2, setPw2]     = useState('');
  const [err, setErr]     = useState('');
  const [ok, setOk]       = useState('');
  const [saving, setSaving] = useState(false);

  // Profile editing
  const [editing, setEditing] = useState(false);
  const [editName, setEditName] = useState(profile.name || '');
  const [editErr, setEditErr] = useState('');
  const [editOk, setEditOk] = useState('');

  async function handlePassword(e) {
    e.preventDefault();
    if (pw.length < 6) return setErr('Password must be at least 6 characters.');
    if (pw !== pw2) return setErr("Passwords don't match.");
    setSaving(true); setErr(''); setOk('');
    try {
      await onSetPassword(pw);
      setOk('Password updated!');
      setPw(''); setPw2('');
    } catch (e) {
      setErr(e.message || 'Failed');
    }
    setSaving(false);
  }

  async function handleProfileSave() {
    if (!editName.trim()) return setEditErr('Name is required.');
    setEditErr(''); setEditOk('');
    try {
      await onUpdateProfile({ name: editName.trim() });
      setEditOk('Profile updated!');
      setEditing(false);
    } catch (e) {
      setEditErr(e.message || 'Failed');
    }
  }

  return (
    <div>
      <div className="page-hdr">
        <div>
          <div className="page-title">Account</div>
          <div className="page-sub">Manage your profile and password</div>
        </div>
      </div>

      {/* Profile Info */}
      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-hdr">
          <span className="card-title">Profile</span>
          {!editing && (
            <button className="btn xs outline" onClick={() => { setEditing(true); setEditName(profile.name || ''); setEditOk(''); }}>Edit</button>
          )}
        </div>
        <div style={{ padding: 20 }}>
          {editing ? (
            <>
              <div className="fgrp">
                <label className="flbl">Name</label>
                <input className="finp" value={editName} onChange={e => setEditName(e.target.value)} style={{ maxWidth: 300 }} />
              </div>
              <div className="frow" style={{ marginTop: 12 }}>
                <div>
                  <div className="flbl" style={{ marginBottom: 4 }}>Email</div>
                  <div style={{ fontSize: 14, color: 'var(--muted)' }}>{profile.email}</div>
                </div>
                <div>
                  <div className="flbl" style={{ marginBottom: 4 }}>Role</div>
                  <div style={{ fontSize: 14, color: 'var(--muted)', textTransform: 'capitalize' }}>{profile.role}</div>
                </div>
              </div>
              {editErr && <div className="err" style={{ marginTop: 10 }}>{editErr}</div>}
              {editOk && <div className="success-msg" style={{ marginTop: 10 }}>{editOk}</div>}
              <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
                <button className="btn" onClick={handleProfileSave}>Save</button>
                <button className="btn outline" onClick={() => setEditing(false)}>Cancel</button>
              </div>
            </>
          ) : (
            <>
              <div className="frow">
                <div>
                  <div className="flbl" style={{ marginBottom: 4 }}>Name</div>
                  <div style={{ fontSize: 14, color: 'var(--head)' }}>{profile.name}</div>
                </div>
                <div>
                  <div className="flbl" style={{ marginBottom: 4 }}>Email</div>
                  <div style={{ fontSize: 14, color: 'var(--head)' }}>{profile.email}</div>
                </div>
              </div>
              <div className="frow" style={{ marginTop: 16 }}>
                <div>
                  <div className="flbl" style={{ marginBottom: 4 }}>Role</div>
                  <div style={{ fontSize: 14, color: 'var(--head)', textTransform: 'capitalize' }}>{profile.role}</div>
                </div>
                {profile.role === 'apprentice' && (
                  <div>
                    <div className="flbl" style={{ marginBottom: 4 }}>Year Level</div>
                    <div style={{ fontSize: 14, color: 'var(--head)' }}>Year {profile.year || '?'}</div>
                  </div>
                )}
              </div>
              {editOk && <div className="success-msg" style={{ marginTop: 10 }}>{editOk}</div>}
            </>
          )}
        </div>
      </div>

      {/* Change Password */}
      <div className="card">
        <div className="card-hdr"><span className="card-title">Change Password</span></div>
        <div style={{ padding: 20, maxWidth: 400 }}>
          <form onSubmit={handlePassword}>
            <div className="fgrp">
              <label className="flbl">New Password</label>
              <input className="finp" type="password" value={pw} onChange={e => setPw(e.target.value)} placeholder="Min 6 characters" />
            </div>
            <div className="fgrp">
              <label className="flbl">Confirm Password</label>
              <input className="finp" type="password" value={pw2} onChange={e => setPw2(e.target.value)} placeholder="Type it again" />
            </div>
            {err && <div className="err">{err}</div>}
            {ok && <div className="success-msg">{ok}</div>}
            <button className="btn" type="submit" disabled={saving}>{saving ? 'Saving…' : 'Update Password'}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
